import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {isAdmin} from '../../../utils/auth';

import {csvTypeValidation, imageTypeValidation, videoTypeValidation} from '../../../utils/fileValidation';

import * as transfersActionCreators from '../../../actions/transfers';
let allActionCreators = Object.assign({}, transfersActionCreators);


class VideoIframe extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
      loading: true,
      diamondDetails: null, 
    }
	}

	componentWillMount() {
    this.props.productFetchDiamondById(this.props.params.lookupKey)
    .then((respData) => {
      this.setState({ diamondDetails: respData });
    });
  }

	render() {
		return <div className='VideoIframe'>
      {this.state.loading ?
        <div className='viLoading'>
          Loading...
        </div> :
        <div className='viBody'>

        </div>
      }
		</div>;
	}
}
export default VideoIframe;

function mapStateToProps(state) {
  return {
    header: state.header,
    user: state.user,
  };
}

export const VideoIframeContainer = connect(
  mapStateToProps,
  allActionCreators
)(VideoIframe);